<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">申请入驻</span>
      </div>
    </div>
    <div class="form">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="93px"
               style="position:relative;"
               class="demo-ruleForm">
        <div class="formRow">
          <el-form-item label="姓名："
                        prop="name">
            <el-input v-model="ruleForm.name"
                      placeholder="请输入姓名"
                      style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="电话：">
            <el-input v-model="ruleForm.tel"
                      placeholder="请输入专家电话（非必填）"
                      style="width: 300px;"></el-input>
          </el-form-item>
          <!-- <el-form-item label="科室："
                        prop="department">
            <el-select v-model="ruleForm.department"
                       style="width: 300px;"
                       placeholder="请选择科室">
              <el-option v-for="item in departmentOptions"
                         :key="item.id"
                         :label="item.valueText"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->
        </div>
        <div class="formRow">
          <el-form-item label="学历："
                        prop="edu">
            <el-select v-model="ruleForm.edu"
                       style="width: 300px;"
                       placeholder="请选择学历">
              <el-option v-for="item in eduOptions"
                         :key="item.id"
                         :label="item.valueText"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职称/职务："
                        label-width="100px"
                        prop="position">
            <el-select v-model="ruleForm.position"
                       style="width: 300px;"
                       placeholder="请选择职称">
              <el-option v-for="item in positionOptions"
                         :key="item.id"
                         :label="item.valueText"
                         :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="formRow">
          <el-form-item label="科室："
                        prop="department">
            <el-select v-model="ruleForm.department"
                       style="width: 300px;"
                       placeholder="请选择科室">
              <el-option v-for="item in departmentOptions"
                         :key="item.id"
                         :label="item.valueText"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单位："
                        prop="unit">
            <el-input v-model="ruleForm.unit"
                      placeholder="请输入工作单位"
                      style="width: 300px;"></el-input>
          </el-form-item>
        </div>
        <!-- <el-form-item label="标签："
                      prop="labelOne">
          <el-cascader :options="labelOneOptions"
                       placeholder="请选择标签"
                       :props="props"
                       collapse-tags
                       v-model="ruleForm.labelOne"
                       @change="tolabelOne"
                       style="width: 706px;"
                       clearable></el-cascader>
        </el-form-item> -->
        <div v-for="(item, index) in labelOneOptions"
             :key="item.id">
          <el-form-item :label="item.name+'：'"
                        prop="labelOne">
            <el-select v-model="optionsvalues[index].value"
                       style="width: 706px;"
                       multiple
                       placeholder="请选择（可多选）">
              <el-option v-for="optiontime in labelOneOptions[index].queryCoursesInfoList"
                         :key="optiontime.id"
                         :label="optiontime.name"
                         :value="optiontime.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="专长："
                      prop="specialty">
          <el-input type="textarea"
                    class="textarea"
                    placeholder="请输入个人专长，例：擅长糖尿病的诊疗。"
                    style="width: 706px;"
                    v-model="ruleForm.specialty"></el-input>
        </el-form-item>
        <el-form-item label="简介："
                      prop="abstract">
          <el-input type="textarea"
                    class="textarea2"
                    style="width: 706px;"
                    placeholder="请输入个人简介"
                    v-model="ruleForm.abstract"></el-input>
        </el-form-item>
        <el-form-item label="资格证书："
                      label-width="93px"
                      style="position: relative;"
                      prop="certificate">
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="certificateHandleSuccess"
                     :before-upload="beforeAvatarUpload"
                     style="width:105px;height:61px;border: 1px solid #E2E2E2;padding-bottom:-60px;float: left;">
            <img v-if="ruleForm.certificate"
                 :src="ruleForm.certificate"
                 style="width:105px;height:61px"
                 class="avatar" />
            <div v-else
                 style="position: relative;">
              <img src="../../../assets/img/zhengshu.png"
                   style="width:105px;height:61px" />
              <img style=" position: absolute;top: 19px;left: 41px;"
                   src="../../../assets/img/icon/jia3.png" />
            </div>
          </webupload>
          <span style=" position: absolute;bottom: -35px;left:-5px;font-size:12px;">上传医师资格证书1-2</span>
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="certificateHandleSuccess2"
                     :before-upload="beforeAvatarUpload"
                     style="width:105px;height:61px;border: 1px solid #E2E2E2;padding-bottom:-60px;float: left;margin-left:61px">
            <img v-if="ruleForm.certificate2"
                 :src="ruleForm.certificate2"
                 style="width:105px;height:61px"
                 class="avatar" />
            <div v-else
                 style="position: relative;">
              <img src="../../../assets/img/zhengshu.png"
                   style="width:105px;height:61px" />
              <img style=" position: absolute;top: 19px;left: 41px;"
                   src="../../../assets/img/icon/jia3.png" />
            </div>
          </webupload>
          <span style="position: absolute;bottom: -35px;left:163px;font-size:12px;">上传医师资格证书3-4</span>
        </el-form-item>
        <el-form-item label="只支持jpg格式"
                      label-width="114px"
                      style="position:absolute;top:110px;right:0px;"
                      prop="logoImg">
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="logoHandleSuccess"
                     :before-upload="beforeAvatarUpload"
                     style="width:92px;height:92px;border-radius: 50%;background: #0b868613;position:absolute;top:-110px;left:-105px;">
            <img v-if="ruleForm.logoImg"
                 :src="ruleForm.logoImg"
                 style="width:92px;height:92px"
                 class="avatar" />
            <i v-else
               style="padding:26px;color:#0B8586;font-size:40px"
               class="el-icon-plus avatar-uploader-icon"></i>
          </webupload>
          <span style="position:absolute;top:-21px;left:-87px;width:100px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">专家头像</span>
        </el-form-item>
        <el-form-item style="margin-top:50px">
          <div class="xzbtn"
               style="margin-left:180px"
               @click="submitForm">保存</div>
          <div class="xzbtn"
               style="margin-left:10px;background: #9EA2A2;"
               @click="quxiao">取消</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import webupload from '../../../components/webupload/webupload.vue';
export default {
  name: 'expertsEnterUpdate',
  components: {
    webupload
  },
  data () {
    return {
      AuthorId: '',
      ruleForm: {
        name: '',
        tel: '',
        edu: '',
        department: '',
        position: '',
        specialty: '',
        abstract: '',
        unit: '',
        logoImg: '',
        certificate: '',
        certificate2: '',
        certificateId: '',
        certificate2Id: '',
        logoImgId: '',
        labelOne: [],
        labelOnestr: ''
      },
      departmentOptions: [],
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        // tel: [
        //   { required: true, message: '请输入电话', trigger: 'blur' }
        // ],
        labelOne: [
          { required: true, trigger: 'blur' }
        ],
        edu: [
          { required: true, message: '请选择学历', trigger: 'change' }
        ],
        position: [
          { required: true, message: '请选择职称/职务', trigger: 'change' }
        ],
        department: [
          { required: true, message: '请选择科室', trigger: 'change' }
        ],
        specialty: [
          { required: true, message: '请输入专长', trigger: 'blur' }
        ],
        abstract: [
          { required: true, message: '请输入个人简介', trigger: 'blur' }
        ],
        unit: [
          { required: true, message: '请输入工作单位', trigger: 'blur' }
        ],
        logoImg: [
          { required: true, message: '' }
        ],
        certificate: [
          { required: true, message: '' }
        ],
      },
      orgid: 0,
      props: {
        multiple: true,
        value: 'id',
        label: 'name',
        children: 'queryCoursesInfoList'
      },
      labelOneOptions: [],
      optionsvalues: [
        { value: [] },
        { value: [] },
        { value: [] },
        { value: [] }
      ]
    };
  },
  created () {
    this.orgid = Number(this.$route.query.id)
    this.getOptions()
    this.getlabelOneOptions()
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
    }
    this.GetMyStoreList()
  },
  methods: {
    checkTel (value) {
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (reg.test(value)) return false
      else return true
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    getOptions () {
      let arr = [1, 6, 3]
      for (let i = 0; i < arr.length; i++) {
        this.httphelper
          .get('/api/BasicsmesApi/GetCodeResultList', {
            type: arr[i]
          })
          .then(res => {
            if (res.code == 200) {
              if (arr[i] == 1) this.eduOptions = res.data;
              else if (arr[i] == 6) this.positionOptions = res.data;
              else if (arr[i] == 3) this.departmentOptions = res.data;
            }
          });
      }

    },
    getlabelOneOptions () {
      this.httphelper
        .get('/api/CGPExpertApi/GetExpertLabelList').then(res => {
          if (res.code == 200) {
            this.labelOneOptions = res.data.elablist
          }
        });
    },
    certificateHandleSuccess (response) {
      this.ruleForm.certificate = response.ossfileurl;
      this.ruleForm.certificateId = response.resid;
    },
    certificateHandleSuccess2 (response) {
      this.ruleForm.certificate2 = response.ossfileurl;
      this.ruleForm.certificate2Id = response.resid;
    },
    logoHandleSuccess (response) {
      this.ruleForm.logoImg = response.ossfileurl;
      this.ruleForm.logoImgId = response.resid;
    },
    submitForm () {
      var valuess = '';
      for (let i = 0; i < this.labelOneOptions.length; i++) {
        if (valuess == '') valuess = this.optionsvalues[i].value.toString()
        else valuess += ',' + this.optionsvalues[i].value;
      }
      if (this.ruleForm.name == '') return this.$message.warning('姓名不能为空');
      else if (valuess == '') return this.$message.warning('请选择标签');
      else if (this.ruleForm.edu == '') return this.$message.warning('请选择学历');
      else if (this.ruleForm.position == '') return this.$message.warning('请选择职称');
      else if (this.ruleForm.department == '') return this.$message.warning('请选择科室');
      else if (this.ruleForm.specialty == '') return this.$message.warning('专长不能为空');
      else if (this.ruleForm.abstract == '') return this.$message.warning('简介不能为空');
      else if (this.ruleForm.unit == '') return this.$message.warning('工作单位不能为空');
      else if (this.ruleForm.certificate == '' || this.ruleForm.certificate2 == '') return this.$message.warning('请上传资格证书');
      else if (this.ruleForm.logoImg == '') return this.$message.warning('请上传专家头像');
      this.httphelper.post('/api/CGPExpertApi/ExpertEnter', {
        userId: Number(this.AuthorId),
        id: this.orgid,
        Name: this.ruleForm.name,
        Mobile: this.ruleForm.tel.toString(),
        Subjectval: Number(this.ruleForm.department),
        TechTitleval: Number(this.ruleForm.position),
        Educationval: Number(this.ruleForm.edu),
        Unit: this.ruleForm.unit,
        Speciality: this.ruleForm.specialty,
        DetailsInfo: this.ruleForm.abstract,
        Pictureonerid: Number(this.ruleForm.certificateId),
        Picturetworid: Number(this.ruleForm.certificate2Id),
        HeadPictureRid: Number(this.ruleForm.logoImgId),
        labelOne: valuess
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('修改入驻信息成功');
            this.$router.push({
              path: '/user/userExpertsEnter'
            })
          } else if (res.data.code == 206) {
            this.$message.error('当前专家已入驻，无法修改');
            this.$router.push({
              path: '/user/userExpertsEnter'
            })
          } else {
            this.$message.error('修改入驻信息失败');
          }
        });
    },
    quxiao () {
      this.$router.push({
        path: '/user/userExpertsEnter'
      })
    },
    GetMyStoreList () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertStoreInfo', {
        id: this.orgid,
      })
        .then(res => {
          if (res.code == 200) {
            this.ruleForm.name = res.data.name
            this.ruleForm.tel = res.data.mobile
            this.ruleForm.department = res.data.subjectval
            this.ruleForm.position = res.data.techTitleval
            this.ruleForm.edu = res.data.educationval
            this.ruleForm.unit = res.data.unit
            this.ruleForm.specialty = res.data.speciality
            this.ruleForm.abstract = res.data.detailsInfo
            this.ruleForm.certificateId = res.data.credentRidOne
            this.ruleForm.certificate2Id = res.data.credentRidTwo
            this.ruleForm.logoImgId = res.data.headPortraitPid
            this.ruleForm.certificate = res.data.credentUrlOne
            this.ruleForm.certificate2 = res.data.credentUrlTwo
            this.ruleForm.logoImg = res.data.headPortraitUrl
            this.ruleForm.labelOnestr = res.data.labelOne
            this.httphelper
              .get('/api/CGPExpertApi/GetExpertLabelList').then(res => {
                if (res.code == 200) {
                  this.labelOneOptions = res.data.elablist
                  let arr = this.ruleForm.labelOnestr.split(',')
                  //   let num = 0
                  for (let i = 0; i < arr.length; i++) {
                    for (let a = 0; a < this.labelOneOptions.length; a++) {
                      for (let b = 0; b < this.labelOneOptions[a].queryCoursesInfoList.length; b++) {
                        if (this.labelOneOptions[a].queryCoursesInfoList[b].id == arr[i]) {
                          this.optionsvalues[a].value.push(
                            Number(this.labelOneOptions[a].queryCoursesInfoList[b].id))
                        }
                      }
                    }
                  }
                }
              });
          }
        });
    },
    tolabelOne (e) {
      this.ruleForm.labelOnestr = ''
      for (let i = 0; i < e.length; i++) {
        if (this.ruleForm.labelOnestr == '') {
          this.ruleForm.labelOnestr = e[i][1].toString()
        } else {
          this.ruleForm.labelOnestr = this.ruleForm.labelOnestr + ',' + e[i][1]
        }
      }
    }
  }
};
</script>

<style scoped>
.xzbtn {
    margin-top: 12px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
}
.form {
    padding-top: 30px;
}
.formRow {
    width: 799px;
    display: flex;
    justify-content: space-between;
}
.textarea ::v-deep .el-textarea__inner {
    height: 82px;
    font-family: Microsoft YaHei !important;
}
.textarea2 ::v-deep .el-textarea__inner {
    height: 98px;
    font-family: Microsoft YaHei !important;
}
</style>